import { BuscarSorteioVigenteDto } from "@/dtos/BuscarSorteioVigenteDto";
import { api } from "./Api";
import { ApiResult } from "./ApiResult";
import { BuscarPremiosUltimoSorteioDTO } from "@/dtos/BuscarPremiosUltimoSorteioDTO";

class SorteioService {
    async buscarSorteioVigente() {
        let { data: result } = await api.get<ApiResult<BuscarSorteioVigenteDto>>("Sorteio/BuscarSorteioVigente");
        return result
    }

    async buscarTodosSorteios() {
        let { data: result } = await api.get<ApiResult<BuscarSorteioVigenteDto[]>>("Sorteio/BuscarTodosSorteios");
        return result
    }

    async buscarUltimoSorteio() {
        let { data: result } = await api.get<ApiResult<BuscarSorteioVigenteDto>>("Sorteio/BuscarUltimoSorteio");
        return result
    }

    async buscarPremiosPorSorteio(idSorteio: number) {
        let { data: result } = await api.get<ApiResult<BuscarPremiosUltimoSorteioDTO>>(`Premio/BuscarPremiosPorSorteio/${idSorteio}`);
        return result
    }
}

//eslint-disable-next-line
export default new SorteioService();